var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$mq !== 'lg')?_c('div',[(_vm.isCarousel)?_c('stories-stats',{attrs:{"stories":_vm.stories},on:{"select":_vm.selectStory}}):_vm._e(),_c('stories-full-screen',{ref:"SFS"})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }